// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2x4WY","label":"Labeled_label__3cGbr","divider":"Labeled_divider__29uM1"};